<td>{{{name}}}</td>
<td>{{{statusText}}}</td>
<td>{{{frequency}}}</td>
<td>
	<button id="pauseButton" name="pauseButton" class="alert-control-button btn btn-primary x-pause" data-id="{{id}}" title="{{{pauseTooltip}}}"><span><i class="fa {{pauseFaClass}} fa-fw"></i></span></button>
	<button id="editButton" name="editButton" class="alert-control-button btn btn-primary x-edit" data-id="{{id}}" title="{{{JspPublicCodes_JSP_ITEM_ALERTS_EDIT_TOOLTIP}}}"><span><i class="fa fa-pencil fa-fw"></i></span></button>
	<button id="deleteButton" name="deleteButton" class="alert-control-button btn btn-primary x-delete" data-id="{{id}}" title="{{{JspPublicCodes_JSP_ITEM_ALERTS_DELETE_TOOLTIP}}}"><span><i class="fa fa-trash-o fa-fw"></i></span></button>
</td>
<td><a href="{{contextPath}}/myBids/6?page=0&alertId={{id}}">{{{JspPublicCodes_JSP_ITEM_ALERTS_VIEW}}}</a></td>
